<app-breadcrumb></app-breadcrumb>

<section class="mainContent">
  @if (orderList$ | async; as orderList) {
    <div class="container">
      <div class="row list-head">
        <div class="chevron"> </div>
        <div class="col-2">Date of Purchase</div>
        <div class="col">Order #</div>
        <div class="col">Mode</div>
        <div class="col-2">Total Amount</div>
        <div class="col-2">Purchased By</div>
        <div class="col">Country</div>
        <div class="col">Status</div>
      </div>
      @for (order of orderList; track order; let i = $index) {
        <section class="row order-section">
          <div class=col-12>
            <div class="row list-body">
              <div class="chevron">
                <span>@if (order.isCollapsed) {
                  <i class="fas fa-chevron-down clickable" (click)="order.isCollapsed = !order.isCollapsed"></i>
                }</span>
                <span>@if (!order.isCollapsed) {
                  <i class="fas fa-chevron-up clickable" (click)="order.isCollapsed = !order.isCollapsed"></i>
                }</span>
              </div>
              <div class="col-2">
                {{order.formattedTimeOfPurchase}}
              </div>
              <div class="col">{{order.orderNumber || 'n/a'}}</div>
              <div class="col">
                @if (order.paymentIntent.stripe.livemode === false) {
                  <span class="test-order">Test</span>
                }
                @if (order.paymentIntent.stripe.livemode === true) {
                  <span class="live-order">Live</span>
                }
              </div>
              <div class="col-2">{{order.formattedTotalAmount}}</div>
              <div class="col-2">{{order.billingName}}</div>
              <div class="col">{{order.formattedBillingCountry}}</div>
              <div class="col"><span class="status" [ngClass]="{ 'processing': order.status === 'processing' }">{{order.status}}</span></div>
            </div>
            <div class="row">
              <div class="col-12">
                <section [(ngbCollapse)]="order.isCollapsed" class="order-section">
                  <div class="row order-detail">
                    <div class="col-4">
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title">Shipping Details</h5>
                          <dl class="row">
                            <dt class="col-4">Name</dt>
                            <dd class="col-8">{{order.shippingName}}</dd>
                            <dt class="col-4">Address</dt>
                            <dd class="col-8 address">
                              @if (order.shippingAddress_1) {
                                <span>{{order.shippingAddress_1}}<br></span>
                              }
                              @if (order.shippingCity) {
                                <span>{{order.shippingCity}}<br></span>
                              }
                              @if (order.shippingZip) {
                                <span>{{order.shippingZip}}<br></span>
                              }
                              @if (order.shippingState) {
                                <span>{{order.shippingState}}<br></span>
                              }
                              @if (order.shippingCountry) {
                                <span>{{order.shippingCountry}}<br></span>
                              }
                            </dd>
                            <dt class="col-4">Phone</dt>
                            <dd class="col-8">{{order.shippingPhone}}</dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title">Billing Details</h5>
                          <dl class="row">
                            <dt class="col-4">Name</dt>
                            <dd class="col-8">{{order.billingName}}</dd>
                            <dt class="col-4">Address</dt>
                            <dd class="col-8 address">
                              @if (order.billingAddress_1) {
                                <span>{{order.billingAddress_1}}<br></span>
                              }
                              @if (order.billingCity) {
                                <span>{{order.billingCity}}<br></span>
                              }
                              @if (order.billingZip) {
                                <span>{{order.billingZip}}<br></span>
                              }
                              @if (order.billingState) {
                                <span>{{order.billingState}}<br></span>
                              }
                              @if (order.billingCountry) {
                                <span>{{order.billingCountry}}<br></span>
                              }
                            </dd>
                            <dt class="col-4">Phone</dt>
                            <dd class="col-8">{{order.billingPhone}}</dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title">Payment Details</h5>
                          <dl class="row">
                            <dt class="col-4">Status</dt>
                            <dd class="col-8">{{order.paymentIntent.status}}</dd>
                            <dt class="col-4">Amount</dt>
                            <dd class="col-8">{{order.paymentIntent.formattedAmount}}</dd>
                            <dt class="col-4">Paid</dt>
                            <dd class="col-8">{{order.paymentIntent.formattedAmountReceived}}</dd>
                            @if (order.hasCharge) {
                              <dt class="col-4">Method</dt>
                            }
                            @if (order.hasCharge) {
                              <dd class="col-8">{{order.charge.payment_method_details.type}}</dd>
                            }
                            @if (order.paidWithCard) {
                              <dt class="col-4">Brand</dt>
                            }
                            @if (order.paidWithCard) {
                              <dd class="col-8">{{order.charge.payment_method_details.card.brand}}</dd>
                            }
                            @if (order.paidWithCard) {
                              <dt class="col-4">Last 4</dt>
                            }
                            @if (order.paidWithCard) {
                              <dd class="col-8">{{order.charge.payment_method_details.card.last4}}</dd>
                            }
                            <dt class="col-4">Links</dt>
                            <dd class="col-8">
                              <a href="{{paymentIntentUrl(order.paymentIntent)}}" target="_blank"><i class="fas fa-arrow-up-right-from-square clickable"></i> View on Stripe</a><br/>
                              <a href="{{paymentIntentUrl(order.paymentIntent)}}" target="_blank"><i class="fas fa-download clickable"></i> View Receipt</a><br/>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                  @for (product of order.saleItems; track product; let j = $index) {
                    <div class="row sale-items">
                      <div class="col-8 offset-sm-2">
                        <div class="card mb-3">
                          <div class="row g-0">
                            <div class="col-md-4">
                              <a [routerLink]="product.safeProductUrl" target=”_blank”><img [src]="product.safeImageUrl" class="item-image"></a>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body">
                                <h5 class="card-title">{{product.title}}</h5>
                                <p class="card-text">{{product.description}}</p>
                                @if (product.ringSize) {
                                  <p class="card-text">Ring Size: {{product.ringSize}}</p>
                                }
                                @if (product.notes) {
                                  <p class="card-text">Note: {{product.notes}}</p>
                                }
                                <p class="card-text">{{product.formattedPrice}}</p>
                                <p class="card-text"><small class="text-muted">Original Price: {{product.formatted}}</small></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </section>
              </div>
            </div>
          </div>
        </section>
      }
    </div>
  }
</section>
